import AlertAudio from "../../assets/audio/order-alert2.mp3";

const orderAlertAudio = new Audio(AlertAudio);

orderAlertAudio.loop = true;
orderAlertAudio.preload = "auto";

//Tracks whether the browser's autoplay policy has been unlocked
let isAudioUnlocked = false;

//Remember to play notification if any order will come before audio unlocked
let pendingPlay = false;

//Tracks how many times audio was played
let playCount = 0;

//Unlock the audio policy on any user interaction
export const unlockAudio = () => {
  if (isAudioUnlocked) return;

  orderAlertAudio
    .play()
    .then(() => {
      orderAlertAudio.pause();
      orderAlertAudio.currentTime = 0;
      isAudioUnlocked = true;
      console.log("ODS Architecture: Audio policy unlocked successfully");

      if (pendingPlay) {
        console.log(
          "ODS Architecture: Audio played for the order received before the audio unlocked"
        );
        playOrderAlert();
        pendingPlay = false;
      }
    })
    .catch((err) => {
      console.log("ODS Architecture: Audio unlocked failed", err);
    });
};

export const playOrderAlert = () => {
  if (!isAudioUnlocked) {
    pendingPlay = true;
    console.log("ODS Architecture: Audio not unlocked yet — alert queued as pending");
    return;
  }
  try {
    if (orderAlertAudio.paused) {
      orderAlertAudio
        .play()
        .then(() => {
          playCount++;
          console.log(`ODS Architecture: Audio played | Total play count: ${playCount}`);
        })
        .catch((err) => {
          if (err.name === "NotAllowedError") {
            // Browser revoked autoplay permission
            // reset so unlockAudio() can run again
            isAudioUnlocked = false;
            // queue it so it plays after next interaction
            pendingPlay = true;
            console.log(
              "ODS Architecture: Browser blocked audio — autoplay permission was revoked. Waiting for next user interaction to retry.",
              err
            );
          } else {
            console.log("ODS Architecture: Audio play error", err);
          }
        });
    }
  } catch (err) {
    console.log("ODS Architecture: Audio play error", err);
  }
};

export const stopOrderAlert = () => {
  try {
    pendingPlay = false;
    orderAlertAudio.pause();
    orderAlertAudio.currentTime = 0;
    console.log(`ODS Architecture: Audio stopped | Total play count so far: ${playCount}`);
  } catch (err) {
    console.log("ODS Architecture: Audio stop error", err);
  }
};

export default orderAlertAudio;
